// Shorthand for $( document ).ready()
$(function() {
 $(window).resize(function(){
     if($(window).width() <= 749){
       if ($(".footer-block--menu")) {
       $(".footer-block--menu").accordion({
          collapsible: true,
          active: false
        });
       }
     }else{
       // $(".footer-block--menu").accordion("destroy");
     }
  });
  if($(window).width() <= 749){
    if ($(".footer-block--menu")) {
      $(".footer-block--menu").accordion({
        collapsible: true,
        active: false
      });
    }
   }else{
     // $(".footer-block--menu").accordion("destroy");
   }



   var charity = $('.custom_donation_wrapper select').val();
     $(".nice-select .current").attr( "data-value", charity );

    $(".nice-select").click(function(){
      
    });
});








// Global variable allows event-tracker.js to bind event listeners when sidecart is enabled
window.sidecartEnabled = true;

const urlParamsCart = new URLSearchParams(window.location.search);
const opencart = urlParamsCart.get('opencart');
let widgetcart = urlParamsCart.get('widgetcart');
// const hcdCart = urlParamsCart.get('hcd');
  
//enable new logic for subscribe and save checkbox
widgetcart = true;

// const singleSubData = {
//     // single variant ID: sub variant ID
//     //Eco Sheets - FF
//     33433213075591: "34472386134151",
//     //Eco Sheets - FS
//     33433213108359: "34472386166919",
//     //Dish Tabs - FF 2pk
//     39838660460679: "39877785092231",
//     //Dish Tabs - FF 3pk
//     39840865583239: "39877785124999",
//     //Dish Tabs - FF 4pk
//     39840865616007: "39877785157767",
//     //Dish Tabs - LC 2pk
//     39838660493447: "39877785190535",
//     //Dish Tabs - LC 3pk
//     39840865648775: "39877785223303",
//     //Dish Tabs - LC 4pk
//     39840865681543: "39877785256071"
// };

// function checkSingleOrSub(variantID) {
//     for (const [key, value] of Object.entries(singleSubData)) {
//         if (key == variantID) return {id: value, subtype: "single"};
//         if (value == variantID) return {id: key, subtype: "sub"};
//     }
//     return false;
// }

// let variantResult;

// const allvariants = [];
// const singlevariants = [];
// const subvariants = [];
// const singleCharities = [34689809547399,34689809580167,34689809612935,34689809645703,34689809678471];
// const subCharities = [39658647617671,39658647650439,39658647715975,39658647748743,39658647814279];
// var itemArray = [];
// var charityInCart;
// var charityFreq;
// var charityType;
// var charityQuant;
  
// try {
//   var scvariants = null;
//   const objectArray = Object.entries(scvariants);
    
//   objectArray.forEach(([key, value]) => {
//     allvariants.push(parseInt(key, 10));
//     allvariants.push(value.discount_variant_id);
//   });
  
//   objectArray.forEach(([key, value]) => {
//     singlevariants.push(parseInt(key, 10));
//   });
    
//   objectArray.forEach(([key, value]) => {
//     subvariants.push(value.discount_variant_id);
//   });
  
// } catch (error) {
//   console.error(error);
// }

// function getParamCustomer() {
//   var email;

  
//     email = getCookie('email') || '';
//     setCookie('email', '', -1)
  

//   var paramCustomer = '&email=' + encodeURIComponent(email);
//   return email ? paramCustomer : '';
// }

// function getParamDiscount() {
//   var discountCode = getCookie('discount_code');
//   setCookie('discount_code', '', -1)
//   return discountCode ? '&discount=' + encodeURIComponent(discountCode) : '';
//   }

// function ga4BeginCheckoutEvent(discount_code) {
//     const beginSidecartCheckout = new CustomEvent('beginSidecartCheckout', { detail: {cart: CartJS.cart, coupon: discount_code} });
//     document.dispatchEvent(beginSidecartCheckout);
// }

// function gotoCheckout(discount) {
//   ga4BeginCheckoutEvent(discount ? discount : '');
//   var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
//   var paramDomain = 'myshopify_domain=mothersearth.eu';

//   try {
//     var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
//   } catch (err) {
//     var paramLinker = '';
//   }

//   var paramCustomer = getParamCustomer();
//   var paramDiscount = getParamDiscount();

//   window.location = [
//     "https://mothersearth.eu/r/checkout?",
//     paramDomain,
//     paramCart,
//     paramLinker,
//     paramDiscount,
//     paramCustomer
//   ].join('');
// }
  
  jQuery(function(){
 //    var id;
	// // $('.sc-select').niceSelect();
 // //    $('.sc-select-charity').niceSelect();

 //      var charity = $('.custom_donation_wrapper select').val();
 //       $(".sc-select-charity .current").attr( "data-value", charity );

 //      $(".sc-select-charity").click(function(){
        
 //      });

    

    // $('.cart-link').on( "click", function(e) {
    //   e.preventDefault();
    //     if (!$('html, body').hasClass("sidecart-open")) {
    //       const openSidecart = new CustomEvent('openSidecart', { detail: CartJS.cart });
    //       document.dispatchEvent(openSidecart);
    //     }

    //     $('body').addClass("sidecart-open");
    //     $('html').addClass("sidecart-open");
        
    // });
    
    $('.sc-checkout').on( "click", function(e) {
      // e.preventDefault();
      
      // itemArray = CartJS.cart.items;

      // let extraItems = {
      //       'items': []
      //   };
      // let extraItem;

      //   // check if sheet sub exists
      //   var hopeclothcheck = itemArray.some(r=> {
      //       if (r.product_id === 6817603682439) {
      //         return true
      //       }
      //   });

      // function addExtraItems() {
      //   fetch('/cart/add.js', {
      //       method: 'POST',
      //       headers: {
      //           'Content-Type': 'application/json'
      //       },
      //       body: JSON.stringify(extraItems)
      //   })
      //   .then(response => {
      //       gotoCheckout();
      //   })
      //   .catch((error) => {
      //       console.error('Error:', error);
      //       gotoCheckout();
      //   });
      // }
      
      // // Remove any existing charity from cart
      // var anyChar1 = itemArray.some(r=> {
      //   if (r.product_id === 6646523723911) {
      //     jQuery.post('/cart/change.js', { quantity: 0, id: r.id },function() {checkForTrial()}, "json");
      //     return true
      //   }
      // })
      
      // var anyChar2 = itemArray.some(r=> {
      //   if (r.product_id === 5216409780359) {
      //     jQuery.post('/cart/change.js', { quantity: 0, id: r.id },function() {checkForTrial()}, "json");
      //     return true
      //   }
      // })
      
      // if (!anyChar1 && !anyChar2) {
      //   checkForTrial();
      // }
      
      // function checkForTrial() {
      //   var trialID;
      //   var trialProduct = itemArray.some(r=> {
      //     if (r.product_id === 6667265147015) {
      //       trialID = r.id;
      //       return true
      //     }
      //   })
        
      //   if (trialProduct) {
      //     //Theres a trial
      //     if (hopeclothcheck) {
      //       jQuery.post('/cart/update.js', "updates[40223054135431]=1",function() {
      //         jQuery.post('/cart/change.js', { quantity: 0, id: trialID },function() {AddCharity()}, "json");
      //       }, "json");
      //       return
      //     } else {
      //       jQuery.post('/cart/change.js', { quantity: 0, id: trialID },function() {AddCharity()}, "json");
      //     }
          
      //   } else {
      //     //No trial
      //     if (hopeclothcheck) {
      //       jQuery.post('/cart/update.js', "updates[40223054135431]=1",function() {AddCharity()}, "json");
      //       return
      //     }
      //     AddCharity();
      //   }
      // };
      
      function AddCharity() {
        
      //   console.log("Adding");
        
      // var subCharity = itemArray.some(r=> {
      //   if (r.title.includes("Auto renew")) {
      //     charityFreq = r.properties.shipping_interval_frequency;
      //     charityType = r.properties.shipping_interval_unit_type;
      //     charityQuant = r.quantity;
      //     return true
      //   }
      // });

        if (subCharity) {
          //var selectedCharity = parseInt($(".custom_donation_wrapper select").val());
          // var selectedCharity = parseInt($(".sc-select-charity span").attr('data-value'));
          // console.log(selectedCharity);

          // if (hcdCart !== null) {
          //   extraItem = {
          //       'id': subCharities[selectedCharity - 1],
          //       'quantity': charityQuant,
          //       'properties': {
          //         'shipping_interval_frequency': charityFreq,
          //         'shipping_interval_unit_type': charityType
          //       }
          //   }
          //   extraItems.items.push(extraItem);
          //   addExtraItems()
          //   return
          // }
          
          // CartJS.addItem(subCharities[selectedCharity - 1], charityQuant,properties = {"shipping_interval_frequency": charityFreq,"shipping_interval_unit_type": charityType},{
          // "success": function(data, textStatus, jqXHR) {
          //   gotoCheckout();
          // },
          // "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log('Error: ' + errorThrown + '!');
          //   gotoCheckout();
          // }});
        } else {
          //var selectedCharity = parseInt($(".custom_donation_wrapper select").val());
          // var selectedCharity = parseInt($(".sc-select-charity span").attr('data-value'));
          // console.log(selectedCharity);

          // if (hcdCart !== null) {
          //   extraItem = {
          //       'id': subCharities[selectedCharity - 1],
          //       'quantity': charityQuant
          //   }
          //   extraItems.items.push(extraItem);
          //   addExtraItems()
          //   return
          // }
          
          // CartJS.addItem(singleCharities[selectedCharity - 1], charityQuant,undefined,{
          // "success": function(data, textStatus, jqXHR) {
          //     gotoCheckout();
            
          // },
          // "error": function(jqXHR, textStatus, errorThrown) {
          //     console.log('Error: ' + errorThrown + '!');
          //   gotoCheckout();
          // }});
          
        }
        
      }
      
      
      
    });
    
//      $('#sc-items').on( "change", 'select', function(e) {
//       e.stopPropagation();
//        var index = $(this).attr("index");
//        var quantity = $(this).attr("quantity");
//        var frequency = $(this).val();
//        var unit_type = $(this).attr("unit-type");
//        console.log(index + " " +frequency + " " + unit_type);
//        CartJS.updateItem(index,quantity, properties = {"shipping_interval_frequency": frequency,"shipping_interval_unit_type": unit_type});
//     });
    
//      $('.custom_donation_wrapper').on( "change", 'select', function(e) {
//       e.stopPropagation();
//        var charity = $(this).val();
//        $(".sc-select-charity .current").attr( "data-value", charity );
//     });
    
//     CartJS.Utils = {
//       unwrapKeys: function(obj, type, override) {
//         var key, unwrapped, unwrappedKey, value;
//         if (type == null) {
//           type = 'properties';
//         }
//         unwrapped = {};
//         for (key in obj) {
//           value = obj[key];
//           unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
//           unwrapped[unwrappedKey] = override != null ? override : value;
//         }
//         return unwrapped;
//       }
//     };
    
// $( 'form[action="/cart/add"]').each(function() {
//   $( this ).attr('data-cart-submit', '');
// });


    // $('#AddToCart').on( "click", function(e) {

      
    //   //tiktok track
    //   ttq.track('AddToCart');
    //   //taboola track
    //   _tfa.push({notify: 'event', name: 'atc', id: 1352224});
    //       /*

          
    //   e.preventDefault();
    //   e.stopPropagation();
      
    //   var dataArray, id, properties, quantity;
    //   dataArray = $('form[action="/cart/add"]').serializeArray();
    //   id = void 0;
      
    //   quantity = void 0;
    //   properties = {};
      
    //   jQuery.each(dataArray, function(i, item) {
    //     if (item.name === 'id') {
    //       return id = item.value;
    //     } else if (item.name === 'quantity') {
    //       return quantity = item.value;
    //     } else if (item.name === 'selling_plan') {
    //       return properties.selling_plan = item.value;
    //     } else if (item.name.match(/^properties\[[\w-_ ]*\]$/)) {
    //       return properties[item.name] = item.value;
    //     }
    //   });
    //   CartJS.addItem(id, quantity, CartJS.Utils.unwrapKeys(properties));
    //       */
    // });

    
    //  $('#sidecart').on( "click", '.sc-sub', function(e) {
    //   e.stopPropagation();

       
    //    var id = parseInt($(this).attr("data-variant-id"), 10);
    //    var sub = parseInt($(this).attr("data-sub"), 10);
    //    var unit_type = $(this).attr("unit-type");

    //     if (widgetcart !== null) {
    //         variantResult = checkSingleOrSub(id);
    //         if (sub == 1) {
    //             $(this).find(".sc-sub").show().attr("data-sub", 0);
    //             jQuery.post('/cart/change.js', {quantity: 0, id: id}, function () {
    //                 CartJS.addItem(variantResult.id, 1);
    //             }, "json");
    //         } else {
    //             $(this).find(".sc-sub").show().attr("data-sub", 1);
    //             jQuery.post('/cart/change.js', {quantity: 0, id: id}, function () {
    //                 CartJS.addItem(variantResult.id, 1, properties = {
    //                     "shipping_interval_frequency": "1",
    //                     "shipping_interval_unit_type": unit_type
    //                 });
    //             }, "json");
    //         }
    //     return
    //     }
       
    //    if (sub == 1) {
    //      var nextvariable = allvariants.indexOf(id) - 1;
    //      $(this).find(".sc-sub").show().attr( "data-sub", 0 );
    //      //CartJS.removeItemById(id);
         
    //      jQuery.post('/cart/change.js', { quantity: 0, id: id },function() {
    //        CartJS.addItem(allvariants[nextvariable], 1);
    //      }, "json");
    //    } else {
    //      $(this).find(".sc-sub").show().attr( "data-sub", 1 );
    //      var nextvariable = allvariants.indexOf(id) + 1;
    //      //CartJS.removeItemById(id);
    //      jQuery.post('/cart/change.js', { quantity: 0, id: id },function() {
    //        CartJS.addItem(allvariants[nextvariable], 1,properties = {"shipping_interval_frequency": "1","shipping_interval_unit_type": unit_type});
    //      }, "json");

         
    //    }
       
    // });
    
    // $('.sc-shipping').on( "click", function(e) {
    //   e.preventDefault();
    //     $(this).children('.sc-tooltip').toggleClass('sc-show-tooltip');
    // });
    
    // $('.sc-close').on( "click", function(e) {
    //   e.preventDefault();
    //     $('body').removeClass("sidecart-open");
    //     $('html').removeClass("sidecart-open");
    // });
    
    // $('.sidecart-overlay').on( "click", function(e) {
    //   e.preventDefault();
    //     $('body').removeClass("sidecart-open");
    //   	$('html').removeClass("sidecart-open");
    // });
    
//     $(document).on('cart.requestComplete', function(event, cart) {
//       // Event handling here on REQUEST COMPLETE

//       console.log(cart);

//       if (!$('html, body').hasClass("sidecart-open")) {
//         const openSidecart = new CustomEvent('openSidecart', { detail: CartJS.cart });
//         document.dispatchEvent(openSidecart);
//       }

//       // check if free hope cloth exists
//        var cartItemArray = CartJS.cart.items;
//         var freehc = cartItemArray.some(r=> {
//             if (r.product_id === 6817603682439) {
//               return true
//             }
//         });

//         if (freehc) {
//           // check if sheet sub exists
//           var freehcsub = cartItemArray.some(r=> {
//               if (r.product_id === 5132556304519) {
//                 return true
//               }
//           });

//           if (!freehcsub) {
//             CartJS.updateItemById(40223054135431, 0);
//             //jQuery.post('/cart/update.js', "updates[40223054135431]=0");
//           }
            
//         }
      
//       $('body').addClass("sidecart-open");
//       $('html').addClass("sidecart-open");
      
//       var itemArray = CartJS.cart.items;
//       var charityFound = itemArray.some(r=> {
//         if (r.product_id === 5216409780359 || r.product_id === 6646523723911) {
//           $('.sc-itemcount').text(CartJS.cart.items.length - 1);
//           return true
//         }
//       })
      
//       if (!charityFound) {
//         $('.sc-itemcount').text(CartJS.cart.items.length);
//       }
      
//     $('.sc-circle').removeClass("sc-circle");
//     $('.sc-select').niceSelect('update');
//       //$('.sc-select-charity').niceSelect('update');
//        //var charity = $('.custom_donation_wrapper select').val();
//        //$(".sc-select-charity .current").attr( "data-value", charity );
      
      
//       $('.sc-item').each(function() {
//         $(this).find(".sc-sub").hide().removeAttr( "data-sub").find(".sc-checked").removeClass("sc-unchecked");
//         $(this).find(".sc-selector").hide();
//         id = parseInt($(this).attr("data-variant-id"), 10);
        
//         if (widgetcart !== null) {
//             variantResult = checkSingleOrSub(id);
//             if (variantResult) {
//                 if (variantResult.subtype == "single") {
//                     $(this).find(".sc-checked").addClass("sc-unchecked");
//                     $(this).find(".sc-sub").show().attr("data-sub", 0).attr("unit-type", "Months");
//                 }
//                 if (variantResult.subtype == "sub") {
//                     $(this).find(".sc-sub").show().attr("data-sub", 1);
//                     $(this).find(".sc-selector").show();
//                 }
//             }
//         return
//         }
        
//         if (allvariants.indexOf(id) > -1) {
//           if (singlevariants.indexOf(id) > -1) {
//             $(this).find(".sc-checked").addClass("sc-unchecked");
//             $(this).find(".sc-sub").show().attr( "data-sub", 0 ).attr("unit-type", "Months");
//           }
//           if (subvariants.indexOf(id) > -1) {
//             $(this).find(".sc-sub").show().attr( "data-sub", 1 );
//             $(this).find(".sc-selector").show();
//           }
//         }
//       });
 
      
// });
    
//     $(function() {
//     // Event handling here on CART READY
//       console.log("slidecart ready");

      
      
//       $('.sc-select').niceSelect('update');
//       $('.sc-select-charity').niceSelect('update');
      
//        var charity = $('.custom_donation_wrapper select').val();
//        $(".sc-select-charity .current").attr( "data-value", charity );
//       console.log("test" + charity )
      
//       $('.sc-item').each(function() {
//         $(this).find(".sc-sub").hide().removeAttr( "data-sub").find(".sc-checked").removeClass("sc-unchecked");
//         $(this).find(".sc-selector").hide();
//         id = parseInt($(this).attr("data-variant-id"), 10);
        
//         if (widgetcart !== null) {
//             variantResult = checkSingleOrSub(id);
//             if (variantResult) {
//                 if (variantResult.subtype == "single") {
//                     $(this).find(".sc-checked").addClass("sc-unchecked");
//                     $(this).find(".sc-sub").show().attr("data-sub", 0).attr("unit-type", "Months");
//                 }
//                 if (variantResult.subtype == "sub") {
//                     $(this).find(".sc-sub").show().attr("data-sub", 1);
//                     $(this).find(".sc-selector").show();
//                 }
//             }
//         return
//         }
        
//         if (allvariants.indexOf(id) > -1) {
//           if (singlevariants.indexOf(id) > -1) {
//             $(this).find(".sc-checked").addClass("sc-unchecked");
//             $(this).find(".sc-sub").show().attr( "data-sub", 0 ).attr("unit-type", "Months");
//           }
//           if (subvariants.indexOf(id) > -1) {
//             $(this).find(".sc-sub").show().attr( "data-sub", 1 );
//             $(this).find(".sc-selector").show();
//           }
//         }
//       });
      
//       if (opencart !== null) {
//         $('body').addClass("sidecart-open");
//         $('html').addClass("sidecart-open");

//         if (!$('html, body').hasClass("sidecart-open")) {
//           const openSidecart = new CustomEvent('openSidecart', { detail: CartJS.cart });
//           document.dispatchEvent(openSidecart);
//         }
//       }
      

// });
    
    
const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

    
  });


